import { Router } from 'vue-router';
import projectConfig from '@/config/config';
import { useGlobalStore } from '@/store/globalStore';
import { setStorage, getStorage } from '@fe/utils';
import { getAccessToken } from '@/utils/weixin';
import { getPermission as getPermissionFun } from '@/utils/utils';
import { showFailToast } from 'vant';
import useAxios from '@/utils/useAxios';
import api from '@/api/api';

export const setToken = (router: Router) => {
  router.beforeEach((to, from) => {
    if (to.query.token) {
      localStorage.setItem(projectConfig.tokenKey, to.query.token as string);
    }
    return true;
  });
};

export const checkToken = (router: Router) => {
  router.beforeEach(async (to, from) => {
    // 如果是扫码上传的功能，则需要判断当前扫码的是不是之前已经登陆的商户，如果不是则需要调中台切换租户接口
    if (to.name === 'AccessoryUpload' || to.name === 'UploadList') {
      // 存一份router参数
      setStorage('routerParams', to.params);
    }
    if (to.name === 'ContractSign') {
      localStorage.removeItem(projectConfig.tokenKey);
    }
    let checkToken = to.meta && to.meta.checkToken;
    if (typeof checkToken !== 'boolean') checkToken = true;
    if (checkToken === false) {
      return true;
    } else {
      const token = localStorage.getItem(projectConfig.tokenKey) || '';
      if (token) {
        return true;
      } else {
        if (projectConfig.isWeixin) {
          if (projectConfig.wxConfig.checkAuthor) {
            // 存储授权完成  回调后需要进入的页面路由
            setStorage('backAuthorRouter', to);
            // 调用微信获取token
            getAccessToken();

            return false;
          } else {
            return true;
          }
        } else {
          showFailToast('登陆信息失效请重新登陆');
          return '/login';
        }
      }
    }
  });
};

// 路由钩子 获取用户权限
export const getPermission = async (router: Router) => {
  router.beforeEach(async (to, from) => {
    // 每个路由都会校验是否需要token 若不需要请指定meta.checkToken为false
    let checkToken = to.meta && to.meta.checkToken;
    if (typeof checkToken !== 'boolean') checkToken = true;
    const store = useGlobalStore();
    if (checkToken && !store.isAcquiredPermission) {
      // 获取权限
      let res = await getPermissionFun({ isCheck: false });
      if (res.status !== 0) {
        return res.data;
      }
    }
    return true;
  });
};
// 路由钩子 判断登录状态
export const checkLoginState = (router: Router) => {
  router.beforeEach((to, from) => {
    const notToken = to.meta && to.meta.notToken;
    if (!notToken) {
      const token = localStorage.getItem(projectConfig.tokenKey);
      if (!token) {
        logoutClear();
        return '/login';
      }
    }
    return true;
  });
};
// 路由钩子 判断页面是否需要缓存
export const setKeepAlive = (router: Router) => {
  router.beforeEach((to, from) => {
    if (projectConfig.system.keepAlive) {
      if (to.meta.keepAlive && to.meta.keepAlive === true) {
        const store = useGlobalStore();
        const keepAliveRouter = store.keepAliveRouter || [];
        const keepAliveName = to.meta.keepAliveName || to.name;
        const idx = keepAliveRouter.findIndex((name: string) => name === keepAliveName);
        if (idx === -1) {
          store.addKeepAlive(keepAliveName as string);
        }
      }
    }
    return true;
  });
};

// 路由钩子 设置页面title
export const setTitle = (router: Router) => {
  router.beforeEach((to, from) => {
    let title = to.meta && (to.meta.title as string);
    title = title || projectConfig.system.name;
    document.title = title;
    return true;
  });
};
export function logoutClear() {
  localStorage.removeItem('Authorization');
  localStorage.removeItem('userData');
}
